<template>
  <div>
      <v-card color="transparent" flat>
          <v-toolbar color="transparent" flat>
              <v-toolbar-title class="font-weight-bold">{{ $t('geneticsAndBreeding.selectAnimal') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" outlined @click="$router.push({name: 'GeneticsListV2'})">{{ $t('geneticsAndBreeding.cancel') }}</v-btn>
              <v-btn color="primary" class="ml-2" depressed @click="animalSelected" :disabled="selected.length<1"> {{ $t('geneticsAndBreeding.next') }}</v-btn>
          </v-toolbar>
      </v-card>
      <v-card class="pa-4">
          <v-data-table
              :headers="headers"
              :items="animals"
              v-model="selected"
              show-select
              item-key="animalNumber"
              single-select
              :items-per-page="10"
              :loading="loading"
              loading-text="Loading Animals... Please wait"
              hide-default-footer
              :options.sync="tableOptions"
              :server-items-length="totalRecords"
              :header-props="{
              'sort-icon': 'mdi-unfold-more-horizontal'
            }"
          >
              <template v-slot:top>
                  <div class="d-flex mt-5">
                      <v-text-field
                          prepend-inner-icon="mdi-magnify"
                          outlined
                          height="5px"
                          :placeholder="$t('geneticsAndBreeding.searchBy')"
                          dense
                          v-model="search"
                          class="shrink"
                          @input="resetSearchOnEmpty"
                      ></v-text-field>
                      <v-btn
                          :disabled="search.length < 1"
                          color="primary"
                          height="40"
                          width="40"
                          max-width="40"
                          outlined
                          class="ml-8"
                          @click="searchEPDAnimal"
                      >
                          <v-icon>mdi-filter-outline</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <div class="py-1 title">
                          {{ from }} - {{ to }} of {{ totalRecords }}
                      </div>
                      <v-btn
                          class="mx-2"
                          fab
                          small
                          outlined
                          color="primary"
                          :disabled="tableOptions.page <= 1"
                          @click="pageChange(false)"
                      >
                          <v-icon dark> mdi-chevron-left </v-icon>
                      </v-btn>
                      <v-btn
                          class="mx-2"
                          fab
                          small
                          outlined
                          color="primary"
                          :disabled="tableOptions.page >= totalPages"
                          @click="pageChange(true)"
                      >
                          <v-icon dark> mdi-chevron-right </v-icon>
                      </v-btn>
                  </div>
              </template>
              <template v-slot:progress>
                  <v-progress-linear
                      color="primary"
                      :height="8"
                      indeterminate
                  ></v-progress-linear>
              </template>
              <template v-slot:item.dob="{item}">
                 <span>{{ ( !item.dob || item.dob == '0000-00-00') ? '' : item.dob }}</span>
              </template>
              <template v-slot:item.status="{item}">
                  <v-btn style="background: #E5F8F1;" color="#00BD73" outlined rounded >{{item.status || 'N/A'}}</v-btn>
              </template>
          </v-data-table>
      </v-card>
  </div>
</template>
<script>
import AnimalService from "@/_services/AnimalService";
export default {
  data() {
      return {
          loading: false,
          search: "",
          selected: [],
          totalRecords: 0,
          totalPages: 0,
          to: 0,
          from: 0,
          tableOptions: {},
          headers: [
              {
                  text: this.$t('geneticsAndBreeding.animalID'),
                  align: "start",
                  value: "animalNumber",
                  class: "black--text",
                  sortable: true,
              },
              {
                  text: this.$t('geneticsAndBreeding.tag'),
                  value: "tagNumber",
                  class: "black--text",
                  sortable: false,
              },
              { text: this.$t('geneticsAndBreeding.birthDate'), value: "dob", class: "black--text", sortable: true },
              {
                  text: this.$t('geneticsAndBreeding.gender'),
                  value: "gender",
                  class: "black--text",
                  sortable: false,
              },
              {
                  text: this.$t('geneticsAndBreeding.breed'),
                  value: "breed",
                  class: "black--text",
                  sortable: false,
              },
              {
                  text: this.$t('geneticsAndBreeding.regDate'),
                  value: "createdAt",
                  class: "black--text",
                  sortable: true,
              },
              {
                  text: this.$t('geneticsAndBreeding.status'),
                  value: "status",
                  class: "black--text",
                  sortable: false,
              },
          ],
          animals: [
              {
                  animalId: "dlsjfklds",
                  tag: "sdjklf jsdlfj"
              },
              {
                  animalId: "afsda",
                  tag: "adsa jsdlfj"
              }
          ],
      }
  },
  watch: {
      tableOptions: {
          handler() {
              this.getAnimalsData();
          },
          deep: true,
      },
  },
  methods: {
      animalSelected() {
          this.$emit('animal-selected', this.selected)
      },
      getAnimalsData() {
          this.loading = true;
          AnimalService.getAnimals(
              'notInEpd',
              this.tableOptions,
              this.search
          )
          .then((res) => {
              console.log('sss', res)
              if (res.success) {
                  this.animals = res.data.rows;
                  this.totalRecords = res.data.totalRows;
              //     this.pageCount = Math.ceil(
              //     this.totalAnimals / this.tableOptions.itemsPerPage
              //     );
                  this.totalPages = Math.ceil(
                      this.totalRecords / this.tableOptions.itemsPerPage
                  );
                  this.from =
                      (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
                  this.to =
                      this.tableOptions.page * this.tableOptions.itemsPerPage -
                      (this.tableOptions.itemsPerPage - res.data.numRows);
                  this.loading = false;
              }
          })
          .catch((err) => {
              this.loading = false;
              console.log(err);
          });
      },
      pageChange(t) {
          if (t) this.tableOptions.page = this.tableOptions.page + 1;
          else this.tableOptions.page = this.tableOptions.page - 1;

          this.getAnimalsData();
      },
      searchEPDAnimal() {
          if (this.search == "") return;
          this.tableOptions.page = 1;
          this.getAnimalsData();
      },

      resetSearchOnEmpty() {
          if (this.search !== "") return;
          this.tableOptions.page = 1;
          this.getAnimalsData();
      },

  }
}
</script>
<style scoped>
::v-deep .v-data-table-header__icon {
display: inline-block;
opacity: 100 !important;
transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>